import { noteFields } from './fields'
import { noteFieldTypes } from './fieldTypes'

export const noteInputs = () => {
    const inputs = noteFieldTypes()

    return {
        mainForm: [inputs[noteFields.NOTE_TITLE], inputs[noteFields.NOTE_DATE], inputs[noteFields.NOTE], inputs[noteFields.NOTE_AGENT_ID]],
    }
}
